/**
 * Pasa un literal del wire generado al enum de `@fiado/type-kit` con el mismo valor.
 * No compila si el OpenAPI trae un valor que el enum no tiene.
 */
export function wireEnum<E extends string>(value: `${E}`): E {
    return value as E;
}
